import React from 'react';

import {
    ButtonGroup,
    Div,

    RichCell,
    PanelHeader,
    Group,
    List,
    Cell,
    PanelHeaderButton,
    NativeSelect,

    SplitCol,
    SplitLayout,

    ModalRoot,
    ModalPage,
    ModalPageHeader,
    FormItem,
    Textarea, SimpleCell, Spinner, Alert
} from '@vkontakte/vkui';
import axios from "axios";
import {Button, FormLayout, Select, Input, Search} from '@vkontakte/vkui';
import {
    Icon24AddCircleOutline,
    Icon24ArticleBoxOutline, Icon24BrowserBack,
    Icon24InfoCircleOutline,
    Icon24QuestionOutline, Icon24ShoppingCartOutline
} from '@vkontakte/icons';
import {
    Icon16MoneyCircle,
    Icon12CheckCircle,
    Icon16TruckOutline,
    Icon20ScissorsOutline,
    Icon16Lock
} from '@vkontakte/icons';
import {Icon16ListBulletOutline} from '@vkontakte/icons';
import {Icon16ArrowshapeRightOutline} from '@vkontakte/icons';
import MD5 from "crypto-js/md5";
import {
    Icon24Cancel,
    Icon24RefreshOutline, Icon28HelpOutline
} from '@vkontakte/icons';

import CartApi from "../api/CartApi";
import * as constants from "../assets/constants";
import Scissors from "./Scissors";
import Series from "./Series";
import {
    AdaptivityContext, checkGroupBlocked, checkProductBlocked, formatOrderBlockHelpText, getProductOrderBlock, getSavedSubdivision,
    getScladBlockReason, keyEmpty,
    simpleDateTimeFormat
} from "../assets/constants";
import PathDocs from "./PathDocs";
import Reserves from "./Reserves";
import cartApi from "../api/CartApi";
import {bool} from "prop-types";
import IMask from "imask";
import HelpButton from "../assets/HelpButton";
import ParamsList from "./ParamsList";
import moment from "moment";
import checkMods from "./checkMods";
import CopyToClipBoard from "../assets/CopyToClipboardButton";
import BaseApi from "../api/BaseApi";
import BaseComponent from "../components/BaseComponent";
import ProductImageCarousel from "../components/ProductImageCarousel";

const scladCellStyle = {display: "flex", justifyContent: "center", marginLeft: "10px", marginTop: "10px"}
const scladCellStyleMob = {marginLeft: "10px", marginTop: "10px"}

const scladTitleStyle = {
    display: "flex",
    flexDirection: 'column',
    alignItems: "center",
    marginLeft: "10px",
    marginTop: "10px"
}
const scladTitleStyleMob = {marginLeft: "10px", marginTop: "10px"}

const scladRowStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "10px",
    marginTop: "10px",
    border: "#dadada 1px solid",

}
const scladRowStyleMob = {marginLeft: "10px", marginTop: "10px"}

const scladInputCellStyle = {
    display: "flex",
    flexDirection: "row-reverse",
    flexWrap: 'wrap',
    justifyContent: "space-between",
    marginLeft: "10px",
    marginTop: "10px",
    paddingRight: '10px'
}
const scladInputCellStyleMob = {marginLeft: "10px", marginTop: "10px"}

class Sclads extends BaseComponent {

    scissors_current_item = null
    readOnlyHelpText = 'Склад доступен только на просмотр в соответствии с правилами контроля доступности брендов, обратитесь к администратору'

    isProductReadOnly = () => {
        return this.props.product && (this.props.product.read_only == '1' || this.props.product.read_only === true)
    }

    getOrderBlock = () => {
        return getProductOrderBlock(this.props.product, this.props.user)
    }

    receiveMessage = (event) => {
        if (event.data == 'cartSaved') {
            CartApi.getItems(() => this.getItems())
        }
        if (event.data == 'scladsGoGetBack') {
            if (this.state.activeModal == null) {
                this.cmdBack()
            } else {
                this.modalBack()
            }
        }
        if (event.data.type == 'divisionSelected') {

            this.setState({selectedSubdivision: event.data.value, page: 1})

            setTimeout(() => this.getItems(), 800)
        }
    }

    async componentDidMount() {
        super.componentDidMount()


        if ((this.props.product.isUnique == '0' && this.props.user.meta.settings.auto_request_data != '1') || this.state.auto_request_pending === true || (this.props.product.isUnique == '0' && this.props.edit_cart_item != undefined)) {
            this.getItems();
        } else {
            setTimeout(() => {
                this.getOstAndPriceByRequest()
            }, 300)
        }
        const inventoryUrl = `/?app=inventory&act=getList&iDisplayLength=200&iDisplayStart=0&product_id=${encodeURIComponent(this.props.product.id)}`
        const inventarisation_data = await BaseApi.get(inventoryUrl)

        const comment = localStorage.getItem(constants.current_order_comment_key)
        this.setState({current_order_comment: comment, inventarisation_data: inventarisation_data.data ?? null})
    }


    setCurrentUnit = (unit_id) => {
        let new_unit = this.props.product.units.find((el) => {
            return el.external_id == unit_id
        });
        this.setState({current_unit: new_unit})
    }
    getPriceByRequest = (index) => {
        let old = this.state.items;
        old[index].loading_price = true;
        this.setState({items: old});
        const body = new FormData()

        const el = old[index];

        const headers = {
            //'Content-Type': 'multipart/form-data',
            'ID': this.props.username,
            'PASS': MD5(this.props.password)
        };

        body.append("product_id", this.props.product.id)
        body.append("sclad_id", el.sclad_id)
        axios.post(this.props.base_url + '/?app=partnersproducts&act=createPriceRequest', body,
            {
                withCredentials: true

            }
        ).then((response) => {
            console.log(response)
            let data2 = response.data;

            old[index].loading_price = false

            let last_price = 0;
            let last_price_unit = this.state.current_unit

            if (data2.price != undefined) {
                if (data2.price != 0 && data2.unit != keyEmpty) {
                    let new_unit = this.props.product.units.find((el) => {
                        return el.external_id == data2.unit
                    });
                    old[index].unit_price = new_unit
                    old[index].manual_price = data2.price
                    old[index].base_price = data2.price
                    old[index].is_manual = true

                    last_price_unit = new_unit
                    last_price = data2.price
                } else {
                    old[index].unit_price = undefined
                    old[index].manual_price = 0
                    old[index].base_price = 0
                    old[index].is_manual = true
                }
            }
            console.log(old)
            this.setState({items: old, last_price: last_price, last_price_unit: last_price_unit})

        })

    }
    changeLastDiscount = (e) => {
        this.setState({last_discount: e.target.value, last_fix_price: undefined});
    }
    changeLastFixPrice = (e) => {
        let old_price = this.state.last_price

        const fixed_price = e.target.value * 1;
        if (fixed_price == 0) return;


        const discount = (old_price - fixed_price) / old_price * 100;
        this.setState({last_discount: discount, last_fix_price: fixed_price});
    }
    changeOrder = (e, index) => {

        let value = e.target.value.replace(',', '.')
        const match = value.match('([0-9]+[\.\,]?([0-9]{1,3})?)')
//        console.log(match)
        if (value !== '') {
            if (!match || value * 1 == 0) return
        }
        this.noRender = true
        let old = this.state.items;
        old[index].quantity = match ? match[0] : '';
        old[index].from_mods = false
        old[index].order_unit = this.state.current_unit;
        this.setState({items: old});
    }


    showFirmFit = (qnt) => {
        const names = ['protect_phone', 'protect_fio']
        let old = this.state.doc_data
        old.docs.map((doc, index) => {
            names.map((name, indexN) => {
                let len = doc.meta[name].toString().length

                doc.meta[name] = doc.meta[name].toString().substring(0, len - 4)
                while (doc.meta[name].toString().length < len) {
                    doc.meta[name] = doc.meta[name] + '*'
                }
            })
        })
        this.setState({currentQnt: qnt, doc_data: old})
        this.setActiveModal(constants.MODAL_FIRM_FIT_DOCS)

    }
    setCurrentQnt = (qnt, index, unit, dont_mods = false) => {
        let old = this.state.items;
        let item_ = old[index]
        old[index].quantity = (qnt * this.state.current_item.order_unit.K / unit.K).toFixed(3).toString().replace('.0000', '').replace('.000', '')
        old[index].order_unit = unit
        old[index].from_mods = true
        if (dont_mods) {
            old[index].dont_mods = true
        }
        console.log(item_)
        this.setState({items: old});
        this.setCurrentUnit(unit.external_id)
        this.modalBack()
    }
    AddEditToCart = async () => {
        const orderBlock = this.getOrderBlock()
        if (orderBlock.blocked) {
            window.postMessage({
                type: 'helpMessage',
                text: orderBlock.reason_text || this.readOnlyHelpText,
                timeout: 8000
            })
            return
        }

        const simpleCartHasFirmFit = CartApi.getFirmFitCartQnt() > 0
        const simpleCartHasPrimavera = CartApi.getPrimaveraCartQnt() > 0
        const no_deny_firm_fit_club = this.props.user.meta.settings && this.props.user.meta.settings.no_deny_firm_fit_club == '1'
        if (!no_deny_firm_fit_club) {
            if (this.props.product.is_firm_fit == '0' && simpleCartHasFirmFit) {
                window.postMessage({
                    timeout: 8000,
                    type: 'error',
                    text: 'В корзине есть товар из Firm Fit Club. Не возможно добавить товар из общего каталога в корзину. Пожалуйста создайте второй заказ без товаров производителя Firm Fit или очистите корзину от товаров производителя Firm Fit'
                })
                return
            }
            if (this.props.product.is_firm_fit == '1' && !simpleCartHasFirmFit && CartApi.items.length > 0) {
                window.postMessage({
                    timeout: 8000,
                    type: 'error',
                    text: 'В корзине есть товар из общего каталога. Не возможно добавить товар из Firm Fit Club в корзину. Пожалуйста создайте второй заказ без товаров производителя общего каталога или очистите корзину от товаров общего каталога'
                })
                return
            }


        }
        if (this.props.club_mode
            && this.props.current_club.code != 'is_betta_'
            && this.props.current_club.code != 'is_lq'
            && this.props.current_club.code != 'is_primavera'
            && this.state.current_phone == '' && !this.state.ask_phone) {
            this.setActiveModal(constants.MODAL_GET_PHONE)
            return
        }
        let hasErrors = false
        let hasEdit = false
        let i
        let len = this.state.items.length
        const krat_unit = this.props.product.krat_unit

        for (i = 0; i < len; i++) {
            let item = this.state.items[i];

            if (item.order_unit && (item.quantity != undefined && item.quantity > 0 || this.props.edit_cart_item != undefined)) {

                const mods = new checkMods({
                    setState: this.setState,
                    showFirmFit: this.showFirmFit, krat_unit, ...this.props
                }, this.state)
                if (item.num_ser * 1 < 2 || item.sclad_id === -1) {
                    hasErrors = await mods.checkMods(item, i)
                } else {
                    hasErrors = false
                }
                if (item.num_ser * 1 > 1 || (this.props.product.isUnique == '1' && item.sclad_id !== -1)) {

                    continue;
                }
                if (hasErrors === false) {


                    if (this.props.parent_product_id !== undefined && this.props.parent_product_id !== null) {
                        item.parent_product_id = this.props.parent_product_id
                    }
                    let {current_unit} = this.state


                    if (krat_unit !== null) {
                        current_unit = krat_unit
                    }
                    item.meta_id = this.props.product.id;

                    item.unit_id = current_unit.external_id
                    item.unit_name = current_unit.title
                    item.unit = current_unit


                    if (item.num_ser * 1 < 2 || item.sclad_id === -1) {
                        item.quantity = (item.quantity * item.order_unit.K / current_unit.K).toFixed(3).toString().replace('.000', '')
                        if (item.firstSeria && item.firstSeria.id) {
                            item.series_id = item.firstSeria.id
                        }
                    } else {
                        item.quantity = cartApi.getSeriesCartQnt(item.series_id, this.props.product.id)
                    }
                    if (item.unit_price) {
                        item.price = ((item.is_manual ? item.manual_price : item.base_price) * current_unit.K / item.unit_price.K).toFixed(2).toString().replace('.00', '')
                    } else {
                        item.price = 0.0;
                    }
                    if (item.cart_id != undefined) {
                        item.id = item.cart_id
                    }
                    hasEdit = true
                    CartApi.addOrEdit(item)

                } else {
                    if (hasErrors === true) {

                    } else {
                        this.setState(hasErrors)
                        this.setActiveModal(constants.MODAL_CHECK_MODS)
                    }
                    break;
                }
            }
        }
        if (hasErrors === false) {
            if (hasEdit) {
                CartApi.saveItems()
            }
            this.props.hideSclads()
        }
    }
    addAllQnt = (index) => {
        let old = this.state.items;
        let item_ = old[index]
        old[index].quantity = (item_.ost_qnt * this.props.product.unit.K / this.state.current_unit.K).toFixed(4).toString().replace('.0000', '')
        old[index].order_unit = this.state.current_unit
        console.log(item_)
        this.setState({items: old});
    }
    setDiscount = () => {
        let old = this.state.items;

        for (let i = 0; i < old.length; i++) {
            old[i].discount = (this.state.last_discount == undefined || this.state.last_discount == 0 ? undefined : this.state.last_discount) * 1
        }
        this.setState({items: old});
        this.modalBack()
    }
    getItems = (current_sclad_group_id = null) => {
        if (current_sclad_group_id == null && this.state.current_sclad_group_id !== null) {
            current_sclad_group_id = this.state.current_sclad_group_id
        }
        this.setState({loading: true})
        let body = new FormData()
        let ost2 = false;
        let hide_prices = false;
        let mode_is_rip = null;
        let sAjaxSource = '/?app=partnersproducts' + (ost2 ? '&ost2=1' : '') + (hide_prices ? '&hide_prices=1' : '') + '&act=getSclads&product_id=' + this.props.product.id
            + '&is_service=' + this.props.product.is_service + '&window_width=' + 1920

            + (this.props.edit_cart_item == undefined ? '' : '&cart_id=' + this.props.edit_cart_item.id)
            + (this.props.edit_cart_item == undefined ? '' : '&sclad_id=' + this.props.edit_cart_item.sclad_external_id)
            + (current_sclad_group_id != null ? '&sclad_group_id=' + current_sclad_group_id : '')
            //+ '&series_id=' + $(obj).data('series_id')
            //+ ('&is_galery=' + ($(obj).data('is_galery') == undefined|| $(obj).data('is_galery') != 1?'0':'1'))
            //+ '&qnt=' + $(obj).data('qnt')
            + (mode_is_rip != null ? '&is_rip=' + mode_is_rip : '');

        this.setState({
            auto_request_pending: false, items: []
        });
        const validSubdivision = getSavedSubdivision(this.props.user)
        if (validSubdivision) {
            body.append('division_id', validSubdivision.external_id)
        }

        axios.post(this.props.base_url + sAjaxSource, body,
            {
                withCredentials: true
            }
        ).then((response) => {


            if (this.props.edit_cart_item != undefined) {
                if (response.data.results == undefined || !response.data.results.length) {
                    response.data.results = []
                    response.data.results.push({})
                }
                response.data.results[0].quantity = this.props.edit_cart_item.quantity ?? 0
                if (response.data.results[0].ost_qnt == undefined) {
                    response.data.results[0].ost_qnt = this.props.edit_cart_item.ost_qnt ?? 0
                }
                response.data.results[0].order_unit = this.props.edit_cart_item.unit
                response.data.results[0].unit_price = this.props.edit_cart_item.unit
                response.data.results[0].img = this.props.edit_cart_item.img
                response.data.results[0].manual_price = this.props.edit_cart_item.price
                response.data.results[0].sclad_name = this.props.edit_cart_item.sclad_name ?? 'Под заказ'
                response.data.results[0].is_manual = false
                response.data.results[0].base_price = this.props.edit_cart_item.price
                response.data.results[0].is_firm_fit = this.props.edit_cart_item.is_firm_fit
                response.data.results[0].is_primavera = this.props.edit_cart_item.is_primavera
                response.data.results[0].is_betta_ = this.props.edit_cart_item.is_betta_
                response.data.results[0].is_lq = this.props.edit_cart_item.is_lq
                response.data.results[0].sclad_id = this.props.edit_cart_item.sclad_id ?? -1
                response.data.results[0].discount = this.props.edit_cart_item.discount
                response.data.results[0].product_id = this.props.edit_cart_item.product_id
                response.data.results[0].cart_id = this.props.edit_cart_item.id
                response.data.results[0].product = this.props.edit_cart_item.product
                response.data.results[0].name = this.props.edit_cart_item.product.name
                if (this.props.edit_cart_item.series_id) {
                    response.data.results[0].series_id = this.props.edit_cart_item.series_id
                    response.data.results[0].series_code = this.props.edit_cart_item.series_code
                }

                if (this.props.edit_cart_item.doc_guid) {
                    response.data.results[0].doc_guid = this.props.edit_cart_item.doc_guid
                    response.data.results[0].doc_name = this.props.edit_cart_item.doc_name
                    response.data.results[0].doc_type = this.props.edit_cart_item.doc_type
                }
                this.setState({
                    last_price: this.props.edit_cart_item.price,
                    last_price_unit: this.props.edit_cart_item.unit
                });
            }
            let items = response.data.results;
            if (this.state.req_price != null && this.state.req_price * 1 > 0 && this.state.req_unit != null) {
                items.map((el, index) => {
                    el.unit_price = this.state.req_unit
                    el.base_price = this.state.req_price
                    el.is_manual = false
                    items[index] = el

                })

            }
            this.setState({items: items})

            this.setState({ask_phone: false})
            this.setState({doc_data: []})

            this.setState({loading: false})

            if (this.props.club_mode) {
                if (this.props.product.is_firm_fit) {
                    BaseApi.get("/?app=partnersproducts&act=checkProductInDocsIsFirmFitClub&product_id=" + this.props.product.id).then((response2) => {

                        const doc_data = response2.data

                        if (doc_data.cnt > 0) {

                            //this.setState({ask_phone: true})
                            this.setState({doc_data: doc_data})
                        }
                    })

                }
                if (this.props.product.is_primavera) {
                    BaseApi.get("/?app=partnersproducts&act=checkProductInDocsIsPrimavera&product_id=" + this.props.product.id).then((response2) => {

                        const doc_data = response2.data

                        if (doc_data.cnt > 0) {

                            //this.setState({ask_phone: true})
                            this.setState({doc_data: doc_data})
                        }
                    })

                }

                if (this.props.product.is_primavera) {
                    BaseApi.get("/?app=partnersproducts&act=checkProductInDocsIsLQBetta&product_id=" + this.props.product.id).then((response2) => {

                        const doc_data = response2.data

                        if (doc_data.cnt > 0) {

                            //this.setState({ask_phone: true})
                            this.setState({doc_data: doc_data})
                        }
                    })

                }
            }

        })

    }


    getOstAndPriceByRequest = () => {
        let body = new FormData()
        let ost2 = false;
        let hide_prices = false;
        let mode_is_rip = false;
        let sAjaxSource = '/?app=partnersproducts&act=createOstAndPriceRequest';
        let id = this.props.product.id

        let sclads = [];

        this.state.items.map((el, index) => {
            sclads.push(el.sclad_id);
        });

        body.append('product_id', id)
        // body.append('sclad_id', sclads)

        const selectedSubdivision = getSavedSubdivision(this.props.user);

        if (selectedSubdivision && selectedSubdivision.external_id) {
            body.append('division_id', selectedSubdivision.external_id)
            body.append('division_name', (selectedSubdivision.name ?? selectedSubdivision.title)
                + (selectedSubdivision.descr ? ' (' + selectedSubdivision.descr + ')' : ''))
        }

        this.setState({
            auto_request_pending: true,
            items: []
        });
        axios.post(this.props.base_url + sAjaxSource, body,
            {
                withCredentials: true
            }
        ).then((response) => {
            console.log(response)

            if (response.data.isEmptyResult && this.props.product.isUnique == '1') {
                this.setState({showAlertEmptyResult: true})
                return
            }
            if (response.data.success == '++ok') {
                let new_price = null;
                let new_unit = null;

                this.lastOstAndPriceResponse = response.data

                if (response.data.data.Цены != undefined && response.data.data.Цены[0] != undefined) {
                    new_price = response.data.data.Цены[0].price;
                    new_unit = this.props.product.units.find((el) => {
                        return el.external_id == response.data.data.Цены[0].unit
                    });

                }

                this.setState({
                    req_price: new_price * 1,
                    req_unit: new_unit,
                    last_price: new_price * 1,
                    last_price_unit: new_unit
                });
            }


            this.getItems()
        })

    };

    constructor(props) {
        super(props);
        this.changeOrder = this.changeOrder.bind(this);
        this.addAllQnt = this.addAllQnt.bind(this);
        this.getOstAndPriceByRequest = this.getOstAndPriceByRequest.bind(this);


        this.modalBack = () => {
            if (!this.state.disableModalBack) {
                this.setActiveModal(this.state.modalHistory[this.state.modalHistory.length - 2]);
            } else {
                window.postMessage('modalBack')
            }
        };
        this.ref = React.createRef();
        const state = {
            auto_request_pending: false,
            items: [],
            current_sclad_group_id: null,
            showScissorsSeries: false,
            current_unit: this.props.edit_cart_item != undefined ? this.props.edit_cart_item.unit : this.props.product.base_unit,
            inventarisation_data: null,
            disableModalBack: false,
            showAlertEmptyResult: false,
            ask_phone: false,
            current_phone: '',
            current_order_comment: '',
            doc_data: {},
            oneSeriaDisabled: false,
            loading: false,
            loadingDeleveryDates: false,
            externalDataRequested: false,
        }
        state.selectedSubdivision = getSavedSubdivision(this.props.user);
        this.state = {
            ...this.state,
            ...state
        }
    }


    showSeries = (item, qntBase, qntUnique, rulon) => {
        //  console.log(item)
        if (item.is_rip == '1' && BaseApi.isOnlyScissors(this.props.user, item.sclad_external_id)) {
            if (rulon) {
                this.showScissors(item, true)
                return
            }
        }

        this.series_current_item = item
        this.qntBase = qntBase
        this.qntUnique = qntUnique

        this.setActiveModal(constants.MODAL_SERIES_ORDER)


    }
    showPathDocs = (item) => {
        this.path_docs_current_item = item

        this.setActiveModal(constants.MODAL_PATH_DOCS)


    }
    getDeliveryDates = () => {

        this.setState({loadingDeleveryDates: true})
        BaseApi.get('/?app=partnersproducts&act=createDateDeliveryRequest').then((data) => {
            if (data.success && Array.isArray(data.data.sclads)) {
                console.log(data.data.sclads)
                const olds = this.state.items

                data.data.sclads.map((el) => {
                    const index = olds.findIndex(item => item.sclad_id === el.scladro_sclad_id)
                    if (index !== -1) {
                        const old = olds[index]
                        old.deliveryDate = el.date
                        olds[index] = old
                    }
                })
                this.setState({items: olds, loadingDeleveryDates: false})
            }
        })
    }
    showScissors = (item, oneSeriaDisabled = false) => {
        this.scissors_current_item = item
        this.setState({oneSeriaDisabled})
        this.setActiveModal(constants.MODAL_SCISSORS)


    }
    setShowScissorsSeries = (hide = false) => {
        this.setState({showScissorsSeries: !hide})
    }

    setScladGroupId = (id) => {
        this.setState({current_sclad_group_id: id})

        setTimeout(() => this.getItems(), id ? 200 : 500)
    }

    saveCurrentPhone = () => {
        window.postMessage({type: 'saveCurrentPhone', value: this.state.current_phone})
        this.setActiveModal(null)
    }
    showReserves = (item) => {
        this.reserves_current_item = item

        this.setActiveModal(constants.MODAL_RESERVES)


    }

    scrollPrev = 0

    checkToolbarScroll() {
        let headerMobStorage = document.getElementsByClassName('mobile-table-storage-header')

        if (!headerMobStorage || headerMobStorage.length === 0) return

        headerMobStorage = headerMobStorage[0]
        const scrolled = window.scrollY

        if (scrolled > 100 && scrolled > this.scrollPrev) {
            headerMobStorage.classList.add('out')
        } else {
            headerMobStorage.classList.remove('out')
        }
        this.scrollPrev = scrolled
    }

    handleScroll() {

        this.checkToolbarScroll()
    }

    render() {


        const {inventarisation_data} = this.state
        const {product} = this.props
        const images_url = this.props.base_url.replace("frontend/", '');
        const sclads_modals = (
            <ModalRoot activeModal={this.state.activeModal}>
                <ModalPage
                    id={constants.MODAL_CHECK_MODS}
                    onClose={this.modalBack}
                    size="l"
                    settlingHeight={100}
                    style={{}}
                    header={
                        <ModalPageHeader className="sclads"
                                         right={<PanelHeaderButton
                                             onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                        >
                            {
                                (this.state.current_item == undefined ? '' :
                                        'Заказ ' + (this.state.current_item.quantity * this.state.current_item.order_unit.K / this.state.current_unit.K).toFixed(3).toString().replace('.0000', '').replace('.000', '')
                                        + this.state.current_unit.title
                                        + ' не кратно упаковке "' + (this.state.current_pack_unit || product.pack_unit).title + '"'
                                )
                            }
                        </ModalPageHeader>
                    }
                >
                    <Group style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "start",
                        padding: "12px"
                        /*background: "#0f65b9",
                        color: "white"*/
                    }}>
                        <div>
                            <p>{'Укажите варианты заказа в ' + this.state.current_unit.title + ', кратный единице измерения "' + (this.state.current_pack_unit || product.pack_unit).title + '"'}</p>

                            {this.state.current_item == undefined ? '' : product.units.map((itemU, indexU) => {
                                    if (product.isUnique == '1' || product.krat_unit) {
                                        if (itemU.external_id != product.pack_unit.external_id) return
                                    }
                                    return <ButtonGroup mode="horizontal" stretched style={{marginBottom: "12px"}}>

                                        <Button stretched
                                                onClick={() => this.setCurrentQnt(this.state.current_min, this.state.current_index, itemU, product.isUnique == '1')}>
                                            {(this.state.current_min * this.state.current_item.order_unit.K / itemU.K).toFixed(3).toString().replace('.0000', '').replace('.000', '') + itemU.title}
                                        </Button>
                                        <Button stretched
                                                onClick={() => this.setCurrentQnt(this.state.current_max, this.state.current_index, itemU, product.isUnique == '1')}>
                                            {(this.state.current_max * this.state.current_item.order_unit.K / itemU.K).toFixed(3).toString().replace('.0000', '').replace('.000', '') + itemU.title}
                                        </Button>
                                        {!product.krat_unit && product.isUnique != '1' && product.is_primavera != '1' && product.is_firm_fit != '1' &&
                                            <Button stretched disabled={this.props.club_mode === true}
                                                    onClick={() => this.setCurrentQnt(this.state.current_item.quantity, this.state.current_index, itemU, true)}>
                                                {(this.state.current_item.quantity * this.state.current_item.order_unit.K / itemU.K).toFixed(3).toString().replace('.0000', '').replace('.000', '') + itemU.title}
                                            </Button>}


                                    </ButtonGroup>
                                }
                            )}
                        </div>
                    </Group>
                </ModalPage>
                <ModalPage
                    id={constants.MODAL_DISCOUNT}
                    onClose={this.modalBack}
                    size="l"
                    settlingHeight={100}
                    style={{}}
                    header={
                        <ModalPageHeader className="sclads"
                                         right={<PanelHeaderButton
                                             onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                        >
                            Установка скидок на товар {[product.name]}
                        </ModalPageHeader>
                    }
                >
                    {this.state.last_price_unit == undefined ? '' : <div style={{marginRight: "20px"}}>
                        <SimpleCell Component="label" multiline
                                    after={(this.state.last_price / this.state.last_price_unit.K * this.state.current_unit.K).toFixed(2) + constants.currency_char}>
                            Цена
                        </SimpleCell>
                        <SimpleCell Component="label"
                                    after={<Input className="order-input" id="inp_discount_percent" autoFocus
                                                  onChange={(e) => this.changeLastDiscount(e)}
                                                  value={this.state.last_discount == undefined ? '' : (this.state.last_discount * 1).toFixed(2).replace('.00', '')}

                                                  type="number"/>}>
                            Скидка в %
                        </SimpleCell>
                        <SimpleCell Component="label" after={<Input className="order-input" id="inp_fix_price"
                                                                    onChange={(e) => this.changeLastFixPrice(e)}
                                                                    value={this.state.last_fix_price == undefined ? '' : this.state.last_fix_price * 1}
                                                                    type="number"/>}>
                            Фикс. Цена
                        </SimpleCell>
                        <SimpleCell Component="label"
                                    after={((this.state.last_price / this.state.last_price_unit.K * this.state.current_unit.K
                                        - this.state.last_price / this.state.last_price_unit.K * this.state.current_unit.K
                                        / 100 * (this.state.last_discount == undefined ? 0 : this.state.last_discount * 1)).toFixed(2)) + constants.currency_char}>
                            Новая цена
                        </SimpleCell>
                        <SimpleCell Component="label" multiline>
                            <Icon28HelpOutline style={{
                                display: 'inline-block',
                                verticalAlign: 'middle',
                                position: 'relative',
                                top: -1,
                                color: 'var(--vkui--color_icon_secondary)'
                            }}/>
                            Напишите -5 и Вы получите скидку в 5%

                        </SimpleCell>
                        <SimpleCell multiline
                                    Component="label">{this.state.last_discount != undefined && this.state.last_discount != 0 ?
                            <span>
                                    Внимание! Установлена новая цена {((this.state.last_price / this.state.last_price_unit.K * this.state.current_unit.K
                                - this.state.last_price / this.state.last_price_unit.K * this.state.current_unit.K
                                / 100 * (this.state.last_discount == undefined ? 0 : this.state.last_discount)).toFixed(2)) + constants.currency_char}!
                                    Скидка составила {(this.state.last_discount * 1).toFixed(2).replace('.00', '')}%
                            </span> : ''}</SimpleCell>
                        <SimpleCell Component="label" size="l">
                            <Button onClick={() => this.setDiscount()}>Применить скидку</Button>
                        </SimpleCell>
                    </div>}
                </ModalPage>
                <ModalPage id={constants.MODAL_SCISSORS}
                           hideCloseButton={true}
                           dynamicContentHeight={true}
                           size="l"

                           settlingHeight={100}
                           style={{overflowY: 'auto'}}

                           header={
                               <ModalPageHeader className="sclads"
                                                before={<PanelHeaderButton onClick={() => {
                                                    this.state.showScissorsSeries ? this.setShowScissorsSeries(true) : this.modalBack()
                                                }}><Icon24BrowserBack/></PanelHeaderButton>}

                               >
                                   Нарезка {this.scissors_current_item ? this.scissors_current_item.sclad_name : ''}
                               </ModalPageHeader>
                           }
                >
                    <Scissors base_url={this.props.base_url}
                              product={product}
                              current_user={this.props.user}
                              sclad={this.scissors_current_item}
                              oneSeriaDisabled={this.state.oneSeriaDisabled}
                              current_unit={this.state.current_unit}
                              hideScissors={() => {
                                  this.setActiveModal(null);
                                  if (this.props.edit_cart_item) {
                                      this.props.hideSclads()
                                  }
                                  if (this.props.refreshState) {
                                      this.props.refreshState()
                                  }
                              }}
                              showScissorsSeries={this.state.showScissorsSeries}
                              setShowScissorsSeries={this.setShowScissorsSeries}

                    />
                </ModalPage>

                <ModalPage id={constants.MODAL_SERIES_ORDER}
                           hideCloseButton={true}
                           size="l"

                           settlingHeight={100}
                           style={{}}

                           header={
                               <ModalPageHeader className="sclads"
                                                before={<PanelHeaderButton onClick={() => {
                                                    this.modalBack()
                                                }}><Icon24BrowserBack/></PanelHeaderButton>}

                               >
                                   Серии {this.series_current_item ? this.series_current_item.sclad_name : ''}
                               </ModalPageHeader>
                           }
                >
                    <Series base_url={this.props.base_url}
                            product={product}
                            qntBase={this.qntBase}
                            qntUnique={this.qntUnique}
                            current_user={this.props.user}
                            sclad={this.series_current_item}
                            current_unit={this.state.current_unit}
                            user={this.props.user}
                            inventarisation_data={this.state.inventarisation_data}
                            setCurrentUnit={this.setCurrentUnit}
                            path={this.props.path}
                            parent={this}
                            hideSeries={() => {
                                this.setActiveModal(null);
                                if (this.props.refreshState) {
                                    this.props.refreshState()
                                }
                            }}
                            setActiveModal={(modal) => {
                                this.setActiveModal(modal)
                            }}

                    />
                </ModalPage>

                <ModalPage id={constants.MODAL_PATH_DOCS}
                           hideCloseButton={AdaptivityContext.isMobile}
                           size="l"
                           onClose={this.modalBack}
                           settlingHeight={100}
                           style={{}}

                           header={
                               <ModalPageHeader className="sclads"
                                                before={<PanelHeaderButton onClick={() => {
                                                    this.modalBack()
                                                }}><Icon24BrowserBack/></PanelHeaderButton>}

                               >
                                   Товары в
                                   пути {this.path_docs_current_item ? this.path_docs_current_item.sclad_name : ''}
                               </ModalPageHeader>
                           }
                >
                    <PathDocs base_url={this.props.base_url}
                              product={product}
                              sclad={this.path_docs_current_item}
                              current_unit={this.state.current_unit}
                              current_user={this.props.user}
                              setCurrentUnit={this.setCurrentUnit}
                              user={this.props.user}
                              path={this.props.path}
                              parent={this}
                              hideSeries={() => {
                                  this.setActiveModal(null);
                                  this.props.refreshState()
                              }}

                    />
                </ModalPage>
                <ModalPage id={constants.MODAL_RESERVES}
                           hideCloseButton={AdaptivityContext.isMobile}
                           size="l"
                           onClose={this.modalBack}
                           settlingHeight={100}
                           style={{}}

                           header={
                               <ModalPageHeader className="sclads"
                                                before={<PanelHeaderButton onClick={() => {
                                                    this.modalBack()
                                                }}><Icon24BrowserBack/></PanelHeaderButton>}

                               >
                                   Резервы {this.reserves_current_item ? this.reserves_current_item.sclad_name : ''}
                               </ModalPageHeader>
                           }
                >
                    <Reserves base_url={this.props.base_url}
                              product={product}
                              sclad={this.reserves_current_item}
                              current_unit={this.state.current_unit}
                              hideReserves={() => {
                                  this.setActiveModal(null);
                                  this.props.refreshState()
                              }}

                    />
                </ModalPage>
                <ModalPage id={constants.MODAL_GET_PHONE}
                           hideCloseButton={AdaptivityContext.isMobile}
                           size="l"
                           onClose={this.modalBack}
                           settlingHeight={100}
                           style={{}}
                           onOpened={
                               () => {
                                   const self = this
                                   let phoneInput = document.getElementById("current_phone_input");

                                   const phoneMask = new IMask(phoneInput, {
                                       mask: "+{7}(000)000-00-00",
                                   });

                                   function phoneInputHandler(e) {

                                       if (phoneMask.unmaskedValue[1] == '8') {
                                           phoneMask.unmaskedValue = '7'
                                           phoneMask.value = phoneMask.unmaskedValue;
                                       }

                                       if (phoneMask.masked.isComplete) {
                                           self.setState({phoneValid: true})
                                       } else {
                                           self.setState({phoneValid: false})
                                       }
                                       self.setState({current_phone: phoneMask.unmaskedValue, value: e.target.value})
                                   }

                                   phoneInput.addEventListener('input', phoneInputHandler)
                               }
                           }
                           header={
                               <ModalPageHeader className="sclads"
                                                before={<PanelHeaderButton onClick={() => {
                                                    this.modalBack()
                                                }}><Icon24BrowserBack/></PanelHeaderButton>}

                               >
                                   Укажите номер телефона клиента
                               </ModalPageHeader>
                           }
                >
                    <Div>
                        <FormLayout>
                            <FormItem top="Введите номер телефона">
                                <Input
                                    id="current_phone_input"
                                    type="text"
                                    placeholder="999 99-99"

                                />
                            </FormItem>
                        </FormLayout>
                        <ButtonGroup stretched>
                            <Button onClick={() => this.saveCurrentPhone()} stretched size="l">Применить</Button>
                            <Button onClick={() => this.setActiveModal(null)} stretched mode="outline"
                                    size="l">Отмена</Button>
                        </ButtonGroup>
                    </Div>
                </ModalPage>

                <ModalPage id={constants.MODAL_FIRM_FIT_DOCS}
                           hideCloseButton={AdaptivityContext.isMobile}
                           settlingHeight={100}
                           size="l"
                           onClose={this.modalBack}
                           header={
                               <ModalPageHeader className="sclads"
                                                before={<PanelHeaderButton onClick={() => {
                                                    this.modalBack()
                                                }}><Icon24BrowserBack/></PanelHeaderButton>}

                               >
                                   Защита сделки
                               </ModalPageHeader>
                           }
                >
                    <Div>
                        <h1>На товар {product.name} с
                            количеством {this.state.currentQnt + this.state.current_unit.title} уже есть заказы с
                            защитой в FirmFit Club</h1>
                        <h1>Проверьте данные заказов:</h1>
                        <List>
                            {this.state.doc_data.docs ? this.state.doc_data.docs.map((child, indexDoc) => (
                                <RichCell multiline key={'ffclub_docs_' + indexDoc}
                                          bottom={[child.meta.protect_phone, ' ', child.meta.protect_fio]}
                                          subhead={<span
                                              style={{fontSize: 'smaller'}}>{child.date} {child.time} </span>}
                                          after={child.user.name}>
                                    {child.NomerDocKIS ? child.NomerDocKIS : child.nomer}
                                </RichCell>
                            )) : ''}
                        </List>
                    </Div>
                </ModalPage>
                <ModalPage id={constants.MODAL_PARAMS_LIST}
                           hideCloseButton={AdaptivityContext.isMobile}
                           settlingHeight={100}
                           size="l"
                           onClose={this.modalBack}
                           header={
                               <ModalPageHeader className="sclads"
                                                before={<PanelHeaderButton onClick={() => {
                                                    this.modalBack()
                                                }}><Icon24BrowserBack/></PanelHeaderButton>}

                               >
                                   Свойства товара {product.name}
                               </ModalPageHeader>
                           }
                >
                    <ParamsList
                        base_url={this.props.base_url}
                        product={product}
                        current_user={this.props.user}
                    />
                </ModalPage>
                <ModalPage id={constants.MODAL_CART_ITEM_COMMENT}
                           hideCloseButton={AdaptivityContext.isMobile}
                           settlingHeight={100}
                           size="l"
                           onClose={this.modalBack}
                           header={
                               <ModalPageHeader className="sclads"
                                                before={<PanelHeaderButton onClick={() => {
                                                    this.modalBack()
                                                }}><Icon24BrowserBack/></PanelHeaderButton>}

                               >
                                   Комментарий на позицию
                               </ModalPageHeader>
                           }
                >
                    <Div>
                        <Textarea rows={15} autoFocus
                                  onFocus={(e) => {
                                      const that = e.target;
                                      setTimeout(() => {
                                          that.selectionStart = that.selectionEnd = 10000
                                      }, 100)
                                  }}
                                  onChange={
                                      (e) => {
                                          window.postMessage({type: 'saveOrderComment', value: e.target.value})
                                          this.setState({current_order_comment: e.target.value})
                                      }
                                  } value={this.state.current_order_comment}></Textarea>
                    </Div>
                </ModalPage>
            </ModalRoot>
        )
        moment.locale('ru')
        setTimeout(() => this.noRender = false, 500)

        /*
                let nenareznoy = false

                if(product.nenareznoy && product.nenareznoy.value == 'да'){
                    nenareznoy = true
                }
        */
        let rulon = false
        const self = this
        const productOrderBlock = this.getOrderBlock()
        const productReadOnly = productOrderBlock.blocked
        if (product.rulon && product.rulon.value == 'да') {
            rulon = true
        }

        const alertEmptyResult = <Alert
            actionsAlign="left"
            actionsLayout="horizontal"
            actions={[
                {
                    title: ' OK',
                    action: () => {
                        this.setState({showAlertEmptyResult: false})
                        /*if(product.isUnique == '1' ) {
                            this.props.hideSclads()
                        }*/
                    },
                    mode: 'cancel',
                },
            ]}
            onClose={() => this.setState({showAlertEmptyResult: false})}
            header="Ошибка получения остатков"
            text={
                <p>Не удалось получить информацию об остатках, 1С вернула пустой ответ. Попробуйте снова чуть позже</p>
            }
        />

        return (
            [<PanelHeader fixed={true} className={'sclads ' +
                (product.name.length < 30 ? 'font18' : (
                    product.name.length > 60 ? 'font13' : ''
                ))}
                          before={<PanelHeaderButton style={{display: 'inline'}} onClick={() => this.cmdBack()}
                                                     key="cmd_back_clads"><Icon24BrowserBack/></PanelHeaderButton>}
                          after={
                              [<NativeSelect style={{zIndex: 23}}
                                             value={this.state.current_unit.external_id}
                                             onChange={(e) => this.setCurrentUnit(e.target.value)}
                              >
                                  {product.units.map((itemU, indexU) => (
                                      <option value={itemU.external_id}>{itemU.title}</option>
                                  ))}
                              </NativeSelect>
                              ]}
            >
                {product.name}<CopyToClipBoard size={36} text={product.name}/>
            </PanelHeader>,
                <Div style={{
                    display: "flex",
                    flexWrap: "nowrap",
                    alignItems: "flex-start",
                    padding: AdaptivityContext.isMobile ? 'inherit' : '3px',
                    marginTop:AdaptivityContext.isMobile? 'inherit': '-14px'
                }}
                     className={AdaptivityContext.isMobile ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
                    <div style={{border: "1px black solid", borderRadius: '5px', padding: '2px'}}>
                        <ProductImageCarousel
                            productId={product.id}
                            mainImage={product.mainImage}
                            images={product.images}
                            imagesUrl={images_url}
                            size={AdaptivityContext.isMobile ? 48 : 78}
                            isMobile={AdaptivityContext.isMobile}
                        />
                    </div>
                    <div style={{width: '100%'}}>
                        <SplitLayout>

                            <SplitCol>

                                {(!(this.props.user && this.props.user.meta.settings && this.props.user.meta.settings.hide_prices == '1'))
                                    && this.state.last_price && this.state.last_price_unit &&
                                    <Button
                                        size="s"
                                        onClick={() => this.setActiveModal(constants.MODAL_DISCOUNT)}>{((this.state.last_price / this.state.last_price_unit.K * this.state.current_unit.K
                                        - this.state.last_price / this.state.last_price_unit.K * this.state.current_unit.K
                                        / 100 * (this.state.last_discount == undefined ? 0 : this.state.last_discount)).toFixed(2)) + constants.currency_char}</Button>}
                                <Button mode="secondary" size="s"
                                        className="btn-toolbar-sclads"
                                        onClick={() => this.setActiveModal(constants.MODAL_PARAMS_LIST)}><Icon24InfoCircleOutline/></Button>
                            </SplitCol>
                            <SplitCol>

                                <NativeSelect
                                    style={{
                                        zIndex: 23,
                                        marginLeft: '10px',
                                        marginTop: '-5px',
                                        width: '150px',
                                        maxHeight: '32px'
                                    }}
                                    value=""

                                    onChange={(e) => {
                                        const value = e.target.value

                                        this.props.hideSclads()

                                        setTimeout(() => {

                                            window.postMessage({type: "saveMainSearch", value: ''})
                                            window.postMessage({type: "applyCurrentGroup", value})
                                        }, 500)
                                    }}
                                >
                                    {product.path.slice().reverse().map((itemP, indexP) => (
                                        <option value={itemP.external_id}>{itemP.name}</option>
                                    ))}
                                </NativeSelect>
                            </SplitCol>
                        </SplitLayout>
                        <SplitLayout>

                            <SplitCol>
                                <Button mode="secondary" size="s" loading={this.state.auto_request_pending == true}
                                        className="btn-toolbar-sclads"
                                        onClick={() => this.getOstAndPriceByRequest()}><Icon24RefreshOutline/></Button>
                                <Button mode="secondary" size="s" sizeY="compact" className="btn-toolbar-sclads"
                                        onClick={() => this.setActiveModal(constants.MODAL_CART_ITEM_COMMENT)}><Icon24ArticleBoxOutline/></Button>
                            </SplitCol>
                            <SplitCol>
                                <Button before={<Icon12CheckCircle/>} size="s"
                                        disabled={this.props.user.tech_docs_blocked == '1' || productReadOnly}
                                        style={{width: "250px", maxwidth: "250px"}}
                                        onClick={() => this.AddEditToCart()}><Icon24ShoppingCartOutline/></Button>
                            </SplitCol>
                        </SplitLayout>
                    </div>
                </Div>,

                <SplitLayout modal={sclads_modals} ref={this.ref}
                             popout={this.state.showAlertEmptyResult ? alertEmptyResult : null}>
                    <SplitCol>
                        {this.state.loading ?
                            <Cell before="Получаем список складов" after={<Spinner size="large"/>}></Cell> : ""}

                        {this.state.items.map((item, index) => {

                                const scladBlockReason = getScladBlockReason(item)

                                const isOnlyScissors = item.is_rip == '1' && rulon && !productOrderBlock.blocked && BaseApi.isOnlyScissors(this.props.user, item.sclad_external_id)

                                let groupAndScladBlocked = checkGroupBlocked(product.path, item.sclad_external_id)

                                if (groupAndScladBlocked === false) {
                                    groupAndScladBlocked = checkProductBlocked(inventarisation_data, item.sclad_external_id, product.id);
                                }
                                const orderDisabled = scladBlockReason.blocked || productOrderBlock.blocked || !!groupAndScladBlocked
                                const isViewOnlyScladReason = scladBlockReason.reason_code === 'sclad_view_only'
                                    || (!scladBlockReason.reason_code && item.disabled == '1' && item.dont_order != '1')
                                const hasSeriesPicker = (item.num_ser * 1 > 1) || ((rulon && item.sclad_id !== -1) || product.isUnique == '1' && item.sclad_id && item.sclad_id !== -1)
                                const showOrderHelp = !hasSeriesPicker && (productOrderBlock.blocked || !!groupAndScladBlocked
                                    || (scladBlockReason.blocked && (!isViewOnlyScladReason || item.num_ser * 1 <= 1)))
                                const orderHelpText = groupAndScladBlocked ? groupAndScladBlocked
                                    : (productOrderBlock.blocked ? productOrderBlock.reason_text : scladBlockReason.reason_text)

                                const isExternalHidden = item.is_external == '1'
                                    && this.props.user.meta.settings.auto_request_data != '1'
                                    && !this.state.externalDataRequested;

                                if (item.is_sclad_group) {
                                    return <SplitLayout className="sclads_one-row"
                                                        style={constants.AdaptivityContext.isMobile ? scladRowStyleMob : scladRowStyle}>

                                        <SplitCol
                                            style={constants.AdaptivityContext.isMobile ? scladTitleStyleMob : scladTitleStyle}
                                            width={constants.AdaptivityContext.isMobile ? 48 : ''}>
                                            <label style={{textAlign: 'center'}}>{item.num_res * 1 > 0 &&
                                            (this.props.user && this.props.user.meta.settings && this.props.user.meta.settings.show_reserves == '1') ?
                                                <Button className="btn-reserves" onClick={() => this.showReserves(item)}
                                                        size="s"
                                                        before={[<Icon16Lock
                                                            styyle={{display: 'inline-block'}}/>, (item.num_res * 1 * product.unit.K / this.state.current_unit.K).toFixed(1).toString().replace('.0', '') + this.state.current_unit.title]}>
                                                    {item.sclad_name.replace('_', ' ')}</Button> : item.sclad_name.replace('<b>', '').replace('</b>', '')}</label>
                                        </SplitCol>
                                        <SplitCol
                                            style={scladCellStyleMob}>
                                            {(item.ost_qnt * product.unit.K / this.state.current_unit.K).toFixed(3).toString().replace('.000', '')}
                                            <b>{this.state.current_unit.title}</b>
                                        </SplitCol>
                                        <SplitCol
                                            style={constants.AdaptivityContext.isMobile ? scladInputCellStyleMob : scladInputCellStyle}
                                            width={constants.AdaptivityContext.isMobile ? 28 : ''}>

                                            <div className="order-input-wrapper">
                                                <Button
                                                    size="L"
                                                    stretched mode="primary"
                                                    style={{maxWidth: '192px'}}
                                                    className={constants.AdaptivityContext.isMobile ? "order-input" : ""}
                                                    onClick={() => this.setScladGroupId(item.group_id)}><Icon24AddCircleOutline/></Button>
                                            </div>
                                        </SplitCol>
                                    </SplitLayout>

                                } else {


                                    let qntBase = 0
                                    let qntUnique = 0

                                    if (product.isUnique == '1' && this.lastOstAndPriceResponse) {

                                        if (this.lastOstAndPriceResponse.baseData && this.lastOstAndPriceResponse.baseData.ost_list && Array.isArray(this.lastOstAndPriceResponse.baseData.ost_list)) {
                                            qntBase = this.lastOstAndPriceResponse.baseData.ost_list.reduce((accumulator, el) => accumulator + (el.Sclad_id == item.sclad_external_id ? el.Qnt : 0), 0)
                                        }

                                        if (this.lastOstAndPriceResponse.data && this.lastOstAndPriceResponse.data.ost_list && Array.isArray(this.lastOstAndPriceResponse.data.ost_list)) {
                                            qntUnique = this.lastOstAndPriceResponse.data.ost_list.reduce((accumulator, el) => accumulator + (el.Sclad_id == item.sclad_external_id ? el.Qnt : 0), 0)
                                        }


                                        item.ost_qnt = qntUnique + qntBase
                                    }
                                    return <SplitLayout className="sclads_one-row"
                                                        style={constants.AdaptivityContext.isMobile ? scladRowStyleMob : scladRowStyle}>

                                        <SplitCol
                                            style={constants.AdaptivityContext.isMobile ? scladTitleStyleMob : scladTitleStyle}
                                            width={constants.AdaptivityContext.isMobile ? 48 : ''}>
                                            <label style={{textAlign: 'center'}}>{item.num_res * 1 > 0 &&
                                            (this.props.user && this.props.user.meta.settings && this.props.user.meta.settings.show_reserves == '1') ?
                                                <Button className="btn-reserves" onClick={() => this.showReserves(item)}
                                                        size="s"
                                                        before={[<Icon16Lock
                                                            styyle={{display: 'inline-block'}}/>, (item.num_res * 1 * product.unit.K / this.state.current_unit.K).toFixed(1).toString().replace('.0', '') + this.state.current_unit.title]}>
                                                    {item.sclad_name.replace('_', ' ')}</Button> : item.sclad_name.replace('<b>', '').replace('</b>', '')}</label>

                                            {(!(this.props.user && this.props.user.meta.settings && this.props.user.meta.settings.hide_prices == '1')) &&
                                                <Button before={AdaptivityContext.isMobile ? '' : <Icon16MoneyCircle/>}
                                                        mode="secondary" size="s" stretched
                                                        style={{maxWidth: '192px', marginBottom: '5px'}}
                                                        after={item.is_manual == undefined || (item.is_manual ? item.manual_price : item.base_price) == 0 || item.discount == undefined || item.discount == 0 ? '' : '-' + (item.discount.toFixed(2).replace('.00', '')) + '%'}
                                                        loading={item.loading_price == true}
                                                        onClick={() => {
                                                            this.getPriceByRequest(index)
                                                        }}>
                                                    {item.unit_price != undefined && item.discount != undefined && item.discount != 0 ?
                                                        <span style={{
                                                            display: 'block',
                                                            textDecoration: 'line-through',
                                                            color: 'red',
                                                            fontSize: 'smaller',
                                                            fontWeight: 300
                                                        }}>
                                                    {((item.is_manual ? item.manual_price : item.base_price) * this.state.current_unit.K / item.unit_price.K
                                                    ).toFixed(2).toString().replace('.00', '') + constants.currency_char}
                                                    </span> : ''}
                                                    {item.unit_price != undefined ?
                                                        ((item.is_manual ? item.manual_price : item.base_price) * this.state.current_unit.K / item.unit_price.K
                                                            - (item.discount == undefined ? 0 : ((item.is_manual ? item.manual_price : item.base_price) * this.state.current_unit.K / item.unit_price.K) / 100 * item.discount)).toFixed(2).toString().replace('.00', '') + constants.currency_char
                                                        : (item.is_manual ? 'Цена не доступна' : 'Запросить цену')}
                                                </Button>}

                                            {!(this.props.user && this.props.user.meta.settings && this.props.user.meta.settings.hide_path_docs == '1') &&
                                            item.path_info != undefined && item.path_info.path_qnt ?
                                                <Div onClick={() => this.showPathDocs(item)} style={{
                                                    fontSize: AdaptivityContext.isMobile ? '13px' : '14px',
                                                    paddingTop: '9px',
                                                    cursor: 'pointer',
                                                    maxHeight: '9px',
                                                    minWidth: !AdaptivityContext.isMobile ? '161px' : 'inherit',
                                                    background: 'orange',
                                                    display: 'flex',
                                                    color: 'white',
                                                    borderRadius: '8px',
                                                    flexWrap: 'wrap',
                                                    justifyContent: 'space-between',
                                                    justifyItems: 'center'
                                                }} size="s">
                                                    <Icon16TruckOutline/> <small>{item.path_info.min_date_in}</small>
                                                    <Icon16ArrowshapeRightOutline/>
                                                    <small>{(item.path_info.path_qnt * product.unit.K / this.state.current_unit.K).toFixed(1).toString().replace('.0', '')}</small><small>{this.state.current_unit.title}</small>
                                                </Div> : ''}


                                        </SplitCol>
                                        <SplitCol
                                            style={scladCellStyleMob}>
                                            {isExternalHidden ?
                                                <Button mode="secondary" size="s"
                                                        loading={this.state.auto_request_pending}
                                                        onClick={() => {
                                                            this.setState({externalDataRequested: true});
                                                            this.getOstAndPriceByRequest();
                                                        }}>
                                                    Показать
                                                </Button>
                                                : [
                                                    (item.ost_qnt * product.unit.K / this.state.current_unit.K).toFixed(3).toString().replace('.000', ''),
                                                    <b>{this.state.current_unit.title}</b>,

                                                    item.in_date && item.in_date != "0" ?
                                                        <span className="sclads_in-date">
                                                        {moment(new Date(item.in_date * 1000)).format(simpleDateTimeFormat)}
                                                            <HelpButton size={18}
                                                                        text={'Время обновления остатков по складу "' + item.sclad_name + '" - ' + moment(new Date(item.in_date * 1000)).format(simpleDateTimeFormat)}/>
                                                    </span> : '',

                                                    <Button mode="secondary" size="s"
                                                            disabled={item.num_ser * 1 > 1 || orderDisabled}
                                                            onClick={() => this.addAllQnt(index)}>
                                                        <Icon16ArrowshapeRightOutline/>
                                                    </Button>,
                                                    <div className="order-input-wrapper"
                                                         style={{fontSize: 'small'}}>{item.firstSeria && item.num_ser * 1 == 1 ? [item.firstSeria.code,
                                                        <CopyToClipBoard size={16} text={item.firstSeria.code}/>] : ''}</div>
                                                ]}
                                        </SplitCol>
                                        <SplitCol
                                            style={constants.AdaptivityContext.isMobile ? scladInputCellStyleMob : scladInputCellStyle}
                                            width={constants.AdaptivityContext.isMobile ? 28 : ''}>

                                            <div className="order-input-wrapper">
                                                {(item.num_ser * 1 > 1) || ((rulon && item.sclad_id !== -1) || product.isUnique == '1' && item.sclad_id && item.sclad_id !== -1) ?
                                                    <Input
                                                        before={isOnlyScissors ?
                                                            <Icon20ScissorsOutline/> : AdaptivityContext.isMobile ? '' :
                                                                <Icon16ListBulletOutline/>}

                                                        after={CartApi.getScladCartQnt(item.sclad_id, product.id) > 0 ? (CartApi.getScladCartQnt(item.sclad_id, product.id) + this.state.current_unit.title) : ''}

                                                        style={{maxWidth: '192px'}}
                                                        onChange={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation()
                                                        }}
                                                        value={""}
                                                        className={constants.AdaptivityContext.isMobile ? "order-input" : ""}
                                                        placeholder="Заказать"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            e.preventDefault();
                                                            this.showSeries(item, qntBase, qntUnique, rulon)
                                                        }}/> :
                                                    [<Input className={constants.AdaptivityContext.isMobile ? "" : ""}
                                                            onChange={(e) => this.changeOrder(e, index)}
                                                            placeholder="Заказать"
                                                            disabled={orderDisabled}
                                                            value={item.order_unit == undefined ? '' :
                                                                (this.noRender ? item.quantity : (item.quantity * 1 > 0 ? (item.quantity * item.order_unit.K / this.state.current_unit.K).toFixed(3).toString().replace('.000', '') : ''))}
                                                            type="text"
                                                    />
                                                    ]}
                                                {showOrderHelp ?
                                                    <HelpButton style={{color: groupAndScladBlocked ? 'red' : ''}}
                                                                icon={groupAndScladBlocked ?
                                                                    <Icon24InfoCircleOutline/> : null}
                                                                text={formatOrderBlockHelpText(orderHelpText)}/> : ''}
                                                {(item.sclad_id == '-1' || item.sclad_id === -1) && !productReadOnly ? <HelpButton
                                                    text="Под заказ нужно указывать в том случае если товара нет ни на одном из складов. Это не резерв, а просто запрос товара, которого сейчас нет!"/> : ''}
                                            </div>

                                            {false && <div className="order-input-wrapper">
                                                <Button size="s" className="order-input" style={{marginTop: '3px'}}
                                                        loading={this.state.loadingDeleveryDates}
                                                        stretched
                                                        mode="primary" width={28}
                                                        onClick={() => this.getDeliveryDates()}>
                                                    {item.deliveryDate ? (item.deliveryDate == '01.01.2050' ? 'Нет данных' : item.deliveryDate) : 'Сроки?'}
                                                </Button>
                                            </div>}
                                            <div className="order-input-wrapper">
                                                {this.props.user.partner_id != 57 && !isOnlyScissors && rulon === true && item.disabled == '0'
                                                && !productReadOnly && (item.is_rip == '1' || this.props.ost2) ?
                                                    <Button size="s" className="order-input" style={{marginTop: '3px'}}
                                                            stretched
                                                            mode="primary" width={28}
                                                            onClick={() => this.showScissors(item)}>
                                                        <Icon20ScissorsOutline/>
                                                    </Button>
                                                    : ''}
                                            </div>

                                        </SplitCol>
                                    </SplitLayout>
                                }
                            }
                        )}
                        {this.state.doc_data.cnt && this.props.club_mode ?
                            <Div className="mobile-table-storage-wrapper-body">
                                Внимание! По данному товару имеются выставленные защиты сделок
                                по {this.props.current_club.name}! Уточните у
                                клиента, делал ли он резервы. Если не делал - введите количество в упаковках для того
                                что бы система сказала Вам, можно ли защитить Вашу продажу!
                            </Div> : ''}
                    </SplitCol>
                </SplitLayout>
            ])
    }

    cmdBack = () => {
        if (this.state.current_sclad_group_id === null) {
            this.props.hideSclads()
        } else {
            this.setScladGroupId(null)
        }
    }
}

export default Sclads;
